<h2 mat-dialog-title>{{ 'vault.incidents.associateUserDialog.title' | t }}</h2>
<mat-dialog-content class="mat-typography">
  <p *ngIf="targetUser && !isLoading">
    {{ 'vault.incidents.associateUserDialog.foundUserMessage' | t }}
    <strong class="email-highlight">"{{ targetUser.email }}"</strong>{{ 'vault.incidents.associateUserDialog.foundUserMessageEnd' | t }}
  </p>
  <p *ngIf="!targetUser && !isLoading">
    {{ 'vault.incidents.associateUserDialog.userNotFoundMessage' | t }}
  </p>
  <mat-spinner
    *ngIf="!targetUser && isLoading"
    mode="indeterminate"
    color="accent"
    diameter="48"
  ></mat-spinner>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="danger" mat-button type="button" (click)="close()">{{ 'common.cancel' | t }}</button>
  <button
    *ngIf="targetUser && !isLoading"
    mat-button
    color="success"
    (click)="submitForm()"
    cdkFocusInitial
  >
    {{ 'common.confirm' | t }}
  </button>
</mat-dialog-actions>